const MapContext = React.createContext()
MapContext.displayName = 'MapContext'

export default MapContext
